export enum Text {
  // Stocks Logo
  ADD_NEW_BROKER = 'Add new broker',
  BROKER = 'Broker Configuration',
  CONNECTED = 'connected',
  TERMINAL = 'Terminal',
  TRADING_ENGINE = 'Trading Engine',
  DISABLE_SERVICE_TO_REMOVE = 'Disable services to remove',
  SELECT_BROKER_VIEW_STOCK = 'Select a broker to view stock performance',
  POSITION_ORDER_VIEW = 'Positions and orders overview',
}
